/* Snatch & Glow consent gate for cart page.
 * Reads cart items, gathers disclaimer:<slug> tags, fetches /pages/disclaimers,
 * stitches matching sections into a scrollable box, gates the checkout button.
 */
(function () {
  'use strict';

  var CONFIG = {
    disclaimersPageUrl: '/pages/disclaimers',
    tagPrefix: 'disclaimer:',
    scrollTolerancePx: 16,
    ipifyUrl: 'https://api.ipify.org?format=json',
    // Only these disclaimers get the customer details + order table
    orderSlugs: ['academy', 'bum-filler']
  };

  var els = {};
  var state = {
    requiredSlugs: [],
    stitchedHtml: '',
    contentSha256: '',
    ip: 'unknown',
    scrollReached: false,
    ready: false,
    hasCourse: false,
    hasTreatment: false,
    hasDeposit: false,
    items: [],
    itemSlugs: {},
    orderItems: []
  };

  var FINANCE = {
    payitmonthly: { label: 'PayItMonthly', note: ['The total finance balance is due to PayItMonthly Ltd. For questions about your finance agreement please contact them via: Phone 0333 212 2141 or Email support@payitmonthly.uk'] },
    zopa: { label: 'Zopa', note: [
      'Complaints regarding the Zopa credit agreement, including affordability, interest, repayment terms, or credit decisions, must be directed to Zopa Bank plc directly. Snatch & Glow cannot resolve lending disputes on Zopa\'s behalf. Contact Zopa at contactus@zopa.com.',
      'For repayments: repayments@zopa.com'
    ] },
    none: { label: 'No finance' }
  };

  var NOTICES = {
    course: 'Courses include digital coursework, which is delivered immediately upon purchase. By purchasing, I expressly consent to receiving the digital content now and I acknowledge that this waives my 14 day cancellation right under the Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013.',
    treatment: 'For any treatment purchase, I understand that I am scheduling a booked appointment time. This booking is non-refundable whether or not I attend, and the fee is forfeited if I do not attend or cancel outside the permitted window, regardless of whether the treatment has been performed.',
    deposit: 'Any deposit or reservation payment is made specifically to secure my place, date, or slot. It is non-refundable in all circumstances and cannot be transferred once paid.'
  };

  function findCheckoutBtn() {
    return document.querySelector('button[name="checkout"], input[name="checkout"], [name="checkout"]');
  }

  function main() {
    els.container = document.getElementById('consent-gate');
    els.checkoutBtn = findCheckoutBtn();
    if (!els.container) return;
    if (!els.checkoutBtn) {
      // Try again shortly if theme JS renders the button later
      return setTimeout(main, 500);
    }
    disableCheckout('Loading consent terms...');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(handleCart)
      .catch(function (err) {
        console.error('consent-gate cart load failed', err);
        failClosed('Could not load your cart. Please refresh the page.');
      });
  }

  function handleCart(cart) {
    if (!cart.items || cart.items.length === 0) {
      hideGate();
      enableCheckout();
      return;
    }
    state.items = cart.items;
    state.hasDeposit = cart.items.some(function (i) {
      return /deposit|reservation/i.test(i.product_title || i.title || '');
    });
    gatherRequiredSlugs(cart.items).then(function (slugs) {
      state.requiredSlugs = slugs;
      state.orderItems = state.items.filter(function (i) {
        return (state.itemSlugs[i.key] || []).some(function (s) { return CONFIG.orderSlugs.indexOf(s) !== -1; });
      });
      state.hasCourse = slugs.indexOf('academy') !== -1;
      state.hasTreatment = slugs.some(function (s) { return s !== 'academy'; });
      if (slugs.length === 0 && !state.hasDeposit) {
        hideGate();
        enableCheckout();
        return;
      }
      return fetchAndRender();
    });
  }

  function gatherRequiredSlugs(items) {
    var cache = {};
    var slugs = {};
    var promises = [];
    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var handle = item.handle;
        if (!cache[handle]) {
          cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); });
        }
        promises.push(cache[handle].then(function (product) {
          var tags = product.tags || [];
          var mine = [];
          for (var j = 0; j < tags.length; j++) {
            var t = String(tags[j]).trim();
            if (t.indexOf(CONFIG.tagPrefix) === 0) {
              slugs[t.slice(CONFIG.tagPrefix.length)] = true;
              mine.push(t.slice(CONFIG.tagPrefix.length));
            }
          }
          state.itemSlugs[item.key] = mine;
        }));
      })(items[i]);
    }
    return Promise.all(promises).then(function () {
      return Object.keys(slugs).sort();
    });
  }

  function fetchAndRender() {
    var needPage = state.requiredSlugs.length > 0;
    var pageFetch = needPage
      ? fetch(CONFIG.disclaimersPageUrl, { credentials: 'same-origin' }).then(function (r) { return r.text(); })
      : Promise.resolve('');
    return Promise.all([pageFetch, fetchIp()]).then(function (results) {
      var pageHtml = results[0];
      state.ip = results[1];
      var sections = needPage ? extractSections(pageHtml, state.requiredSlugs) : [];
      if (needPage && sections.length !== state.requiredSlugs.length) {
        var missing = state.requiredSlugs.filter(function (s) {
          return !sections.find(function (x) { return x.slug === s; });
        });
        failClosed('Configuration issue: missing disclaimers for ' + missing.join(', ') + '. Please contact support.');
        return;
      }
      state.stitchedHtml = sections.map(function (s) { return s.html; }).join('\n');
      var hashInput = state.stitchedHtml + '|notices:' + notices().join('|');
      return sha256(hashInput).then(function (h) {
        state.contentSha256 = h;
        renderGate(sections);
        wireInteractions();
        disableCheckout('Please read and sign below to continue.');
        state.ready = true;
      });
    });
  }

  function notices() {
    var out = [];
    if (state.hasCourse) out.push(NOTICES.course);
    if (state.hasTreatment) out.push(NOTICES.treatment);
    if (state.hasDeposit) out.push(NOTICES.deposit);
    return out;
  }

  function extractSections(pageHtml, requiredSlugs) {
    var doc = new DOMParser().parseFromString(pageHtml, 'text/html');
    var out = [];
    for (var i = 0; i < requiredSlugs.length; i++) {
      var slug = requiredSlugs[i];
      var el = doc.querySelector('section[data-disclaimer="' + slug.replace(/"/g, '\\"') + '"]');
      if (el) {
        out.push({
          slug: slug,
          title: el.getAttribute('data-title') || slug,
          html: el.outerHTML
        });
      }
    }
    return out;
  }

  function sha256(text) {
    if (!(window.crypto && window.crypto.subtle)) return Promise.resolve('nosubtle');
    var buf = new TextEncoder().encode(text);
    return crypto.subtle.digest('SHA-256', buf).then(function (hash) {
      var arr = new Uint8Array(hash);
      var s = '';
      for (var i = 0; i < arr.length; i++) {
        s += arr[i].toString(16).padStart(2, '0');
      }
      return s;
    });
  }

  function fetchIp() {
    return fetch(CONFIG.ipifyUrl, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.ip || 'unknown'; })
      .catch(function () { return 'unknown'; });
  }

  function renderGate(sections) {
    var titles = sections.map(function (s) { return s.title; }).join(', ');
    var noticeList = notices();
    var noticesHtml = noticeList.length
      ? '<div class="cg-notices"><h4>Important notice for your purchase</h4><ul>'
        + noticeList.map(function (n) { return '<li>' + escapeHtml(n) + '</li>'; }).join('')
        + '</ul></div>'
      : '';
    var scrollBoxHtml = sections.length
      ? '<div id="cg-scrollbox" class="cg-scrollbox" tabindex="0">'
          + sections.map(function (s) { return s.html; }).join('\n')
          + '</div>'
          + '<p id="cg-scroll-status" class="cg-scroll-status">Scroll to the bottom of the terms above to continue.</p>'
      : '';
    var headingText = sections.length
      ? 'You have items requiring consent: <strong>' + escapeHtml(titles) + '</strong>. Please scroll to the bottom of the terms below, then type your full name and today\'s date, tick the boxes, and continue to checkout.'
      : 'Please review the notice below, type your full name and today\'s date, tick the boxes, and continue to checkout.';
    els.container.innerHTML =
      '<div class="cg-heading">' +
        '<h3>Consent required to continue</h3>' +
        '<p>' + headingText + '</p>' +
      '</div>' +
      scrollBoxHtml +
      noticesHtml +
      '<div id="cg-signature" class="cg-signature"' + (sections.length ? ' hidden' : '') + '>' +
        '<label>Full name<br><input type="text" id="cg-name" autocomplete="name" required></label>' +
        orderFieldsHtml() +
        '<label>Today\'s date (dd/mm/yyyy)<br><input type="text" id="cg-date" inputmode="numeric" placeholder="' + todayUk() + '" value="' + todayUk() + '" required></label>' +
        '<label class="cg-consent-line">' +
          '<input type="checkbox" id="cg-check-terms">' +
          '<span>I agree to the <a href="/pages/terms-conditions" target="_blank" rel="noopener">Terms &amp; Conditions</a>.</span>' +
        '</label>' +
        '<label class="cg-consent-line">' +
          '<input type="checkbox" id="cg-check-privacy">' +
          '<span>I agree to the <a href="/pages/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</span>' +
        '</label>' +
        '<label class="cg-consent-line">' +
          '<input type="checkbox" id="cg-check">' +
          '<span>I confirm I have read and agree to all terms and notices above. This is my electronic signature and I understand that all treatments, courses, deposits, and reservations are non-refundable and I waive my right to cancel under the Consumer Contracts Regulations.</span>' +
        '</label>' +
      '</div>';
    if (!sections.length) {
      state.scrollReached = true;
    }
    els.scrollbox = document.getElementById('cg-scrollbox');
    els.status = document.getElementById('cg-scroll-status');
    els.sig = document.getElementById('cg-signature');
    els.name = document.getElementById('cg-name');
    els.date = document.getElementById('cg-date');
    els.check = document.getElementById('cg-check');
    els.checkTerms = document.getElementById('cg-check-terms');
    els.checkPrivacy = document.getElementById('cg-check-privacy');
    els.address = document.getElementById('cg-address');
    els.phone = document.getElementById('cg-phone');
    els.summary = document.getElementById('cg-order-summary');
  }

  function needsOrder() { return state.orderItems.length > 0; }

  function money(pence) {
    var v = (Number(pence) || 0) / 100;
    return '\u00a3' + v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function orderFieldsHtml() {
    if (!needsOrder()) return '';
    return '<style>' +
      '.cg-order{margin:6px 0 14px;display:grid;gap:10px}' +
      '.cg-order input[type=text],.cg-order input[type=tel]{width:100%}' +
      '.cg-fin{display:flex;flex-wrap:wrap;gap:8px;margin:8px 0 4px}' +
      '.cg-fin button{width:auto!important;margin:0!important;transition:border-color .15s!important;display:inline-flex;align-items:center;justify-content:center;gap:6px;line-height:1;height:42px;min-height:42px;padding:0 18px;border-radius:999px;border:1.5px solid #f3cfe0;background:#fff;color:#1a1a1a;font:inherit;font-size:14px;font-weight:600;cursor:pointer;letter-spacing:0;text-transform:none;box-shadow:none}' +
      '.cg-fin button:hover{border-color:#f8459f!important}' +
      '#consent-gate .cg-fin button[aria-pressed=true],#consent-gate .cg-fin button[aria-pressed=true]:hover{background:#f8459f!important;background-color:#f8459f!important;background-image:none!important;border-color:#f8459f!important;color:#fff!important}' +
      '.cg-fin button[aria-pressed=true]::before{content:"\\2713"}' +
      '.cg-sum{background:#fff;border:1px solid #f7d8e8;border-radius:12px;padding:14px;margin:8px 0 16px;font-size:14px;line-height:1.5;text-align:left}' +
      '.cg-sum-cust{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:12px}' +
      '.cg-sum h5{margin:0 0 4px;font-size:14px}' +
      '.cg-sum-scroll{overflow-x:auto}' +
      '.cg-sum table{width:100%;border-collapse:collapse}' +
      '.cg-sum th,.cg-sum td{padding:6px 8px;border-bottom:1px solid #f3e3ec;text-align:left;vertical-align:top}' +
      '.cg-sum th{font-size:12px;text-transform:uppercase;letter-spacing:.04em}' +
      '.cg-sum p{margin:2px 0}' +
      '.cg-sum td:nth-child(1),.cg-sum th:nth-child(1){width:1%;white-space:nowrap}' +
      '.cg-sum td:nth-child(3),.cg-sum td:nth-child(4){white-space:nowrap}' +
      '.cg-sum .cg-tot{margin-top:10px}.cg-sum .cg-tot p{margin:4px 0;font-weight:700}' +
      '@media (max-width:600px){.cg-sum-cust{grid-template-columns:1fr}.cg-sum{font-size:13px;padding:12px}.cg-sum th,.cg-sum td{padding:6px 4px}.cg-sum th{font-size:10px}}' +
      '</style>' +
      '<div class="cg-order">' +
        '<label>Address (house number, street, town, postcode)<br><input type="text" id="cg-address" autocomplete="street-address" required></label>' +
        '<label>Phone number<br><input type="text" id="cg-phone" autocomplete="tel" inputmode="tel" required></label>' +
        '<div><strong>Are you paying with finance?</strong>' +
          '<div class="cg-fin" role="group" aria-label="Finance provider">' +
            Object.keys(FINANCE).map(function (k) {
              return '<button type="button" data-fin="' + k + '" aria-pressed="false">' + escapeHtml(FINANCE[k].label) + '</button>';
            }).join('') +
          '</div></div>' +
      '</div>' +
      '<div id="cg-order-summary" class="cg-sum"></div>';
  }

  function financeChoice() {
    var b = document.querySelector('.cg-fin button[aria-pressed="true"]');
    return b ? b.getAttribute('data-fin') : '';
  }

  function orderTotals() {
    var total = 0, deposit = 0;
    state.orderItems.forEach(function (i) {
      total += i.final_line_price;
      if (/deposit|reservation/i.test(i.product_title || i.title || '')) deposit += i.final_line_price;
    });
    return { total: total, deposit: deposit, balance: Math.max(total - deposit, 0) };
  }

  function orderSummaryHtml() {
    var name = escapeHtml(els.name ? els.name.value.trim() : '');
    var addr = escapeHtml(els.address ? els.address.value.trim() : '');
    var phone = escapeHtml(els.phone ? els.phone.value.trim() : '');
    var cust = '<p>Name: ' + name + '</p><p>Address: ' + addr + '</p><p>Phone: ' + phone + '</p>';
    var t = orderTotals();
    var rows = state.orderItems.map(function (i) {
      return '<tr><td>' + i.quantity + '</td><td><strong>' + escapeHtml(i.title) + '</strong></td><td>' +
        money(i.final_price) + '</td><td>' + money(i.final_line_price) + '</td></tr>';
    }).join('');
    var finKey = financeChoice();
    var fin = finKey && finKey !== 'none';
    return '<div class="cg-order-record">' +
      '<div class="cg-sum-cust"><div><h5>Customer Details</h5>' + cust + '</div><div><h5>Ship to</h5>' + cust + '</div></div>' +
      '<div class="cg-sum-scroll"><table><thead><tr><th>Qty</th><th>Description</th><th>Unit price</th><th>Total</th></tr></thead><tbody>' + rows + '</tbody></table></div>' +
      '<div class="cg-tot"><p>SUBTOTAL: ' + money(t.total) + '</p>' +
      (t.deposit ? '<p>DEPOSIT PAID: ' + money(t.deposit) + '</p>' : '') +
      (fin ? '<p>TOTAL FINANCE BALANCE DUE: ' + money(t.balance) + '</p>' : '') +
      '<p>TOTAL: ' + money(t.total) + '</p></div>' +
      (fin ? '<p><strong>Finance provider: ' + escapeHtml(FINANCE[finKey].label) + '</strong></p>' +
        FINANCE[finKey].note.map(function (n) { return '<p>' + escapeHtml(n) + '</p>'; }).join('') : '') +
      '</div>';
  }

  function refreshSummary() {
    if (els.summary) els.summary.innerHTML = orderSummaryHtml();
  }

  function orderFieldsOk() {
    if (!needsOrder()) return true;
    var phoneDigits = els.phone.value.replace(/\D/g, '');
    return els.address.value.trim().length >= 8 && phoneDigits.length >= 10 && !!financeChoice();
  }

  function wireInteractions() {
    if (els.scrollbox) {
      els.scrollbox.addEventListener('scroll', function () {
        var nearBottom = els.scrollbox.scrollTop + els.scrollbox.clientHeight
          >= els.scrollbox.scrollHeight - CONFIG.scrollTolerancePx;
        if (nearBottom && !state.scrollReached) {
          state.scrollReached = true;
          if (els.status) els.status.textContent = 'Terms fully viewed. Please sign below.';
          if (els.sig) els.sig.hidden = false;
        }
        evaluate();
      });
    }
    var inputs = [els.name, els.date, els.check, els.checkTerms, els.checkPrivacy];
    if (needsOrder()) {
      inputs = inputs.concat([els.address, els.phone]);
      [].slice.call(document.querySelectorAll('.cg-fin button')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          [].slice.call(document.querySelectorAll('.cg-fin button')).forEach(function (o) {
            o.setAttribute('aria-pressed', o === btn ? 'true' : 'false');
          });
          evaluate();
        });
      });
      refreshSummary();
    }
    inputs.forEach(function (input) {
      input.addEventListener('input', evaluate);
      input.addEventListener('change', evaluate);
    });
    // Capture-phase click on checkout to intercept before Shopify submission
    document.addEventListener('click', onDocClick, true);
    // Also block form submission if any wraps the button
    var form = els.checkoutBtn.form || els.checkoutBtn.closest('form');
    if (form) {
      form.addEventListener('submit', onFormSubmit, true);
    }
  }

  function evaluate() {
    var dateOk = /^\d{2}\/\d{2}\/\d{4}$/.test(els.date.value.trim());
    var nameOk = els.name.value.trim().length >= 3;
    if (needsOrder()) refreshSummary();
    var ok = state.scrollReached && nameOk && dateOk && orderFieldsOk()
      && els.check.checked && els.checkTerms.checked && els.checkPrivacy.checked;
    if (ok) enableCheckout();
    else disableCheckout('Complete the signature to continue.');
  }

  function isCheckoutTrigger(target) {
    if (!target) return false;
    if (target === els.checkoutBtn) return true;
    if (target.name === 'checkout') return true;
    if (target.closest && target.closest('[name="checkout"]')) return true;
    return false;
  }

  function onDocClick(e) {
    if (!isCheckoutTrigger(e.target)) return;
    if (!state.ready) return;
    if (els.checkoutBtn.disabled) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    saveConsentAndCheckout();
  }

  function onFormSubmit(e) {
    if (!state.ready) return;
    if (els.checkoutBtn.disabled) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  function saveConsentAndCheckout() {
    els.checkoutBtn.disabled = true;
    var origLabel = els.checkoutBtn.textContent;
    els.checkoutBtn.textContent = 'Saving consent...';
    var archive = state.stitchedHtml + (needsOrder() ? '\n' + orderSummaryHtml() : '');
    var hashed = needsOrder()
      ? sha256(archive + '|notices:' + notices().join('|'))
      : Promise.resolve(state.contentSha256);
    hashed.then(function (sha) { return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          consent_signed_name: els.name.value.trim(),
          consent_signed_date_typed: els.date.value.trim(),
          consent_signed_at: new Date().toISOString(),
          consent_disclaimers: state.requiredSlugs.join(','),
          consent_content_sha256: sha,
          consent_archive_html: archive,
          consent_customer_address: needsOrder() ? els.address.value.trim() : '',
          consent_customer_phone: needsOrder() ? els.phone.value.trim() : '',
          consent_finance_provider: needsOrder() ? financeChoice() : '',
          consent_terms_agreed: 'yes',
          consent_privacy_agreed: 'yes',
          consent_notices_shown: notices().length ? Object.keys(NOTICES).filter(function (k) {
            return (k === 'course' && state.hasCourse)
              || (k === 'treatment' && state.hasTreatment)
              || (k === 'deposit' && state.hasDeposit);
          }).join(',') : '',
          consent_waiver_14day: state.hasCourse ? 'yes' : '',
          consent_treatment_nonrefundable: state.hasTreatment ? 'yes' : '',
          consent_deposit_nonrefundable: state.hasDeposit ? 'yes' : '',
          consent_ip: state.ip,
          consent_user_agent: navigator.userAgent
        }
      })
    }); }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed');
      window.location.href = '/checkout';
    }).catch(function (err) {
      console.error('consent save failed', err);
      alert('Could not save your consent. Please try again.');
      els.checkoutBtn.disabled = false;
      els.checkoutBtn.textContent = origLabel;
    });
  }

  function disableCheckout(msg) {
    if (!els.checkoutBtn) return;
    els.checkoutBtn.disabled = true;
    els.checkoutBtn.setAttribute('aria-disabled', 'true');
    els.checkoutBtn.title = msg || '';
    els.checkoutBtn.classList.add('cg-btn-disabled');
  }

  function enableCheckout() {
    if (!els.checkoutBtn) return;
    els.checkoutBtn.disabled = false;
    els.checkoutBtn.removeAttribute('aria-disabled');
    els.checkoutBtn.title = '';
    els.checkoutBtn.classList.remove('cg-btn-disabled');
  }

  function hideGate() { if (els.container) els.container.hidden = true; }

  function failClosed(msg) {
    els.container.innerHTML = '<p class="cg-error">' + escapeHtml(msg) + '</p>';
    disableCheckout(msg);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function todayUk() {
    var d = new Date();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    main();
  }
})();
